import React from 'react';
import { useIntl } from 'react-intl';
import { Layout } from '../../contexts/LayoutContext';
import Header from './sections/Header';
import ToolsSection from './sections/ToolsSection';
import Features from './sections/Features';

const Tools = () => {
  const intl = useIntl();
  return (
    <Layout
      title={intl.formatMessage({
        id: 'k.seo.title',
        defaultMessage: '{titlePage} Schedule and manage your business social media.',
      }, {
        titlePage: intl.formatMessage({
          id: 'tools.header.title',
          defaultMessage: 'Tools',
        }),
      })}
    >
      <Header />
      <ToolsSection />
      <Features />
    </Layout>
  );
};

export default Tools;
